import { render, staticRenderFns } from "./jxsy.vue?vue&type=template&id=da6459e2&scoped=true&"
import script from "./jxsy.vue?vue&type=script&lang=js&"
export * from "./jxsy.vue?vue&type=script&lang=js&"
import style0 from "./jxsy.vue?vue&type=style&index=0&id=da6459e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6459e2",
  null
  
)

export default component.exports